var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 113,
    viewBox: "0 0 100 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1036 72.0434C10.2864 68.2453 0.6521 58.2589 0.6521 48.6987C0.6521 36.7485 10.657 33.6914 15.1036 33.6914C19.5502 33.6914 28.9993 36.7485 29.833 48.6987C30.5 58.2589 20.2913 68.2453 15.1036 72.0434ZM14.2699 59.5373C8.15576 59.5373 3.98706 53.7012 3.98706 48.6987C3.98706 42.8625 8.15576 37.0264 15.1036 37.0264C22.0514 37.0264 26.2201 42.5846 26.2201 48.6987C26.2201 53.7089 21.4956 59.5373 14.2699 59.5373Z",
    fill: "#2F3338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4654 39.2495C68.6482 35.4513 59.0139 25.465 59.0139 15.9048C59.0139 3.95451 69.0188 0.897461 73.4654 0.897461C77.912 0.897461 87.3611 3.95451 88.1948 15.9048C88.8618 25.465 78.6531 35.4513 73.4654 39.2495ZM72.6317 26.7434C66.5176 26.7434 62.3489 20.9072 62.3489 15.9048C62.3489 10.0686 66.5176 4.23242 73.4654 4.23242C80.4132 4.23242 84.5819 9.79069 84.5819 15.9048C84.5819 20.9149 79.8574 26.7434 72.6317 26.7434Z",
    fill: "#2F3338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9047 103.169C58.0876 99.3713 48.4532 89.3849 48.4532 79.8247C48.4532 67.8744 58.4581 64.8174 62.9047 64.8174C67.3514 64.8174 76.8004 67.8744 77.6341 79.8247C78.3011 89.3849 68.0925 99.3713 62.9047 103.169ZM62.071 90.6633C55.9569 90.6633 51.7882 84.8271 51.7882 79.8247C51.7882 73.9885 55.9569 68.1523 62.9047 68.1523C69.8526 68.1523 74.0213 73.7106 74.0213 79.8247C74.0213 84.8349 69.2967 90.6633 62.071 90.6633Z",
    fill: "#2F3338"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8257,
    cy: 48.4207,
    r: 7.50366,
    fill: "#2F3338"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7434,
    cy: 15.071,
    r: 7.50366,
    fill: "#2F3338"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6268,
    cy: 79.5466,
    r: 7.50366,
    fill: "#2F3338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 100.946C19.5502 94.2762 16.0299 82.2333 15.3815 77.0456C20.2727 74.3776 27.0538 64.8174 29.833 60.3708L33.4458 59.537L38.7262 66.7628L33.4458 77.8793L36.7808 79.8247L34.8354 89.2737L28.4434 100.946Z",
    fill: "#2F3338"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.282 108.45C36.1694 107.116 32.6121 104.559 31.2225 103.447L38.7262 89.8296L41.2274 77.8793L38.4483 75.9339L42.8949 65.929L35.1133 55.3683L31.7784 55.9241C34.6431 50.7068 33.5378 44.9388 31.9474 41.1194L30.3888 38.1377C30.8821 38.8786 31.4395 39.8996 31.9474 41.1194L36.7808 50.3659H42.8949V55.9241L49.8427 59.537V66.7628C48.7311 67.7818 46.1743 70.987 44.8403 75.656C43.5063 80.3249 45.7667 87.0504 47.0636 89.8296L42.8949 91.497L39.282 108.45Z",
    fill: "#2F3338"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5696 28.4105C48.4531 27.5212 37.5219 32.6718 33.4458 35.3583L39.0041 46.7528H46.2298V53.9785L53.7335 57.3135V63.4276C55.9568 61.8713 59.6623 61.2969 61.2371 61.2043V55.9239L68.4629 53.9785L73.4653 55.0902L82.6365 48.4203L91.8076 50.0877L93.1972 48.4203C89.6399 42.4173 84.1187 37.9522 81.8027 36.47C76.9114 41.8059 74.2064 43.6957 73.4653 43.9736C70.1304 42.4173 62.812 32.9497 59.5696 28.4105Z",
    fill: "#2F3338"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9218 81.2141C101.479 68.9859 97.5512 56.6651 95.1426 52.0332L93.1973 53.9786L84.0261 52.0332L74.855 59.8148L67.9071 57.5915L64.8501 58.7031V60.9264C72.4093 60.7041 78.0047 68.4301 79.8574 72.3209L94.3089 76.2117L97.9218 81.2141Z",
    fill: "#2F3338"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4508 109.839L46.2299 94.2761L48.7312 93.1645C52.9554 99.612 59.7551 105.856 62.6268 108.172C79.0793 94.8319 81.7102 81.6774 80.9691 76.7676L91.5298 79.5467L95.9764 85.9387C84.4152 115.286 56.1422 114.101 43.4508 109.839Z",
    fill: "#2F3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.ad02f1785734d078b59e127a911e9f1b.svg";
export { ForwardRef as ReactComponent };